import { toastr } from "react-redux-toastr";
import { useMutation } from "@tanstack/react-query";

import { client, handleErrors, getApiErrorMessage } from "utils/api";

const useCreate = ({
  path,
  onSuccess,
  onError,
  success_message = "Utworzono pomyślnie",
  error_message = "Wystąpił błąd",
  success_message_enabled = true,
  error_message_enabled = true,
}) => {
  const { isPending: is_creating, mutateAsync: create } = useMutation({
    mutationFn: (values) => client.post(path, values),
    onSuccess: ({ data }) => {
      if (success_message_enabled) {
        toastr.success("Sukces", success_message);
      }
      onSuccess?.(data);
    },
    onError: (err) => {
      if (error_message_enabled) {
        toastr.error("Błąd", getApiErrorMessage(err, error_message));
      }
      onError?.(handleErrors(err?.response?.data?.errors || []));
    },
  });
  return { is_creating, create };
};

export default useCreate;
